import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
} from "@mui/material";
import API_BASE from "../config";
import { useSnackbar } from "../SnackbarContext";

const CURRENT_YEAR = new Date().getFullYear();

function AddCars({ user, onCarAdded }) {
  const { showSuccess, showError } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [nickname, setNickname] = useState("");

  const handleSubmit = async () => {
    if (!user) return;

    if (!make.trim() || !model.trim() || !year) {
      showError("Make, model, and year are required.");
      return;
    }

    const yearValue = Number(year);
    if (!Number.isInteger(yearValue) || yearValue < 1900 || yearValue > CURRENT_YEAR + 1) {
      showError(`Year must be between 1900 and ${CURRENT_YEAR + 1}.`);
      return;
    }

    try {
      const token = await user.getIdToken();

      const response = await fetch(`${API_BASE}/cars`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          make,
          model,
          year,
          nickname,
        }),
      });

      if (!response.ok) throw new Error("Failed to add car");

      const savedCar = await response.json();
      onCarAdded(savedCar);
      showSuccess("Car added to your garage.");

      // Reset fields + close modal
      setMake("");
      setModel("");
      setYear("");
      setNickname("");
      setOpen(false);
    } catch (error) {
      console.error("Add car error:", error);
      showError("Couldn't add that car. Please try again.");
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        Add Car
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add New Car</DialogTitle>

        <DialogContent>
          <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Make"
              value={make}
              onChange={(e) => setMake(e.target.value)}
              fullWidth
              required
            />
            <TextField
              label="Model"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              fullWidth
              required
            />
            <TextField
              label="Year"
              type="number"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              fullWidth
              required
            />
            <TextField
              label="Nickname (optional)"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              fullWidth
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Save Car
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AddCars;
